import { List } from "immutable"
import { HttpResult } from "widgets-for-react"
import { Availability, WISE_CollectionClient } from "./generated"
import { httpResult } from "./utils"

const client = new WISE_CollectionClient(window.location.origin)

export const fetchAvailability: (wiseId: string) => () => Promise<HttpResult<List<Availability>>> = (wiseId: string) => () => httpResult(async () => {
  const result = await client.getAvailability(Number(wiseId))
  return List<Availability>(result.Result);
})